var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAccountIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "39px",
    viewBox: "0 0 41 39",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Outlined / Action / account_circle")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BUC2VL_MG-28.02.20",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-account_circle",
    transform: "translate(-3.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 47 0 47 45 0 45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,3.75 C12.69,3.75 3.91666667,12.15 3.91666667,22.5 C3.91666667,32.85 12.69,41.25 23.5,41.25 C34.31,41.25 43.0833333,32.85 43.0833333,22.5 C43.0833333,12.15 34.31,3.75 23.5,3.75 Z M13.8454167,34.275 C14.6875,32.5875 19.8183333,30.9375 23.5,30.9375 C27.1816667,30.9375 32.3320833,32.5875 33.1545833,34.275 C30.49125,36.3 27.1425,37.5 23.5,37.5 C19.8575,37.5 16.50875,36.3 13.8454167,34.275 Z M35.955,31.55625 C33.1545833,28.29375 26.3591667,27.1875 23.5,27.1875 C20.6408333,27.1875 13.8454167,28.29375 11.045,31.55625 C9.0475,29.04375 7.83333333,25.9125 7.83333333,22.5 C7.83333333,14.23125 14.86375,7.5 23.5,7.5 C32.13625,7.5 39.1666667,14.23125 39.1666667,22.5 C39.1666667,25.9125 37.9525,29.04375 35.955,31.55625 L35.955,31.55625 Z M23.5,11.25 C19.7008333,11.25 16.6458333,14.175 16.6458333,17.8125 C16.6458333,21.45 19.7008333,24.375 23.5,24.375 C27.2991667,24.375 30.3541667,21.45 30.3541667,17.8125 C30.3541667,14.175 27.2991667,11.25 23.5,11.25 Z M23.5,20.625 C21.8745833,20.625 20.5625,19.36875 20.5625,17.8125 C20.5625,16.25625 21.8745833,15 23.5,15 C25.1254167,15 26.4375,16.25625 26.4375,17.8125 C26.4375,19.36875 25.1254167,20.625 23.5,20.625 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccountIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/account-icon.f92b99eb.svg";
export { ForwardRef as ReactComponent };